const config = require(`./${process.env.NEXT_PUBLIC_SITE}/index.js`);
module.exports = config;
